import React from "react";
import BaseComponent, { errorMap } from "./BaseComponent";
import Modal from "./Modal";
import _, { get } from "lodash";
import ReactPaginate from "react-paginate";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import "./ManagerTools.scss";
import pl from "date-fns/locale/pl";
import {
  parse,
  isAfter,
  isBefore,
  subDays,
  format,
  parseISO,
  startOfWeek,
  endOfWeek,
  getWeek,
} from "date-fns";
import Papa from "papaparse";
import { Multiselect } from "multiselect-react-dropdown";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { Combobox } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/20/solid";
import { useState, useEffect, useMemo } from "react";

registerLocale("pl", pl);

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function CampaignForm({ API, onChange }) {
  const [campaigns, setCampaigns] = useState([]);
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);

  // fetch listy kampanii
  useEffect(() => {
    fetch(`${API}/campaign/list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((r) => r.json())
      .then((json) => {
        if (json.status?.success) {
          setCampaigns(json.data.campaigns);
          const stored = this.props.campaignId;
          const pre = json.data.campaigns.find((c) => c.ident === stored);
          if (pre) setSelected(pre);
        }
      })
      .catch(console.error);
  }, [API]);

  const filtered =
    query === ""
      ? campaigns
      : campaigns.filter((c) =>
          c.ident.toLowerCase().includes(query.toLowerCase())
        );

  // przycisk “Zmień kampanię”
  const handleChangeCampaign = () => {
    if (!selected) return;
    onChange?.(selected.ident); // przekazujemy kampanię bez sessionStorage i reload
  };

  return (
    <div className="flex items-end gap-x-4 absolute top-[-50px]">
      <div className="flex-1">
        <Combobox
          as="div"
          value={selected}
          onChange={(c) => {
            setSelected(c);
            setQuery("");
          }}
        >
          <div className="relative mt-1">
            <Combobox.Input
              className="block w-full rounded-md bg-white py-1.5 pr-12 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm"
              onChange={(e) => setQuery(e.target.value)}
              displayValue={(c) => c?.ident || ""}
              placeholder="Search campaign..."
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none cursor-pointer">
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
            </Combobox.Button>

            {filtered.length > 0 && (
              <Combobox.Options className="absolute z-10 mt-1  h-[200px]    max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                {filtered.map((c) => (
                  <Combobox.Option key={c.uuid} value={c}>
                    {({ active, selected }) => (
                      <div
                        className={classNames(
                          "relative cursor-default select-none py-2 pl-3 pr-9",
                          active ? "bg-indigo-600 text-white" : "text-gray-900"
                        )}
                      >
                        <div className="flex items-center">
                          <span
                            className={classNames(
                              "inline-block h-2 w-2 flex-shrink-0 rounded-full",
                              c.public ? "bg-green-400" : "bg-gray-200"
                            )}
                          />
                          <span
                            className={classNames(
                              "ml-3 truncate",
                              selected ? "font-semibold" : ""
                            )}
                          >
                            {c.ident}
                          </span>
                        </div>
                        {selected && (
                          <span
                            className={classNames(
                              "absolute inset-y-0 right-0 flex items-center pr-4",
                              active ? "text-white" : "text-indigo-600"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" />
                          </span>
                        )}
                      </div>
                    )}
                  </Combobox.Option>
                ))}
              </Combobox.Options>
            )}
          </div>
        </Combobox>
      </div>

      {/* przycisk przywrócony */}
      <button
        type="button"
        onClick={handleChangeCampaign}
        className="rounded-md bg-blue-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 cursor-pointer"
      >
        Set campaign
      </button>
    </div>
  );
}

// Komponent do wczytywania i wyświetlania pliku CSV
class CsvUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      headers: [],
      validating: false,
      error: null,
      errorList: [],
      uuid: null,
      committing: false,
    };
    this.fileInputRef = React.createRef();
    this.handleFile = this.handleFile.bind(this);
    this.handleCommit = this.handleCommit.bind(this);
    this.handleWithdraw = this.handleWithdraw.bind(this);
  }

  handleFile(event) {
    const file = event.target.files[0];
    if (!file) return;

    this.setState({
      validating: true,
      error: null,
      errorList: [],
      uuid: null,
    });

    const formData = new FormData();
    formData.append(
      "_input",
      JSON.stringify({
        campaign: { ident: this.props.campaignId },
      })
    );
    formData.append("_files[]", file);

    fetch(`${this.props.API}/campaign/assignment/import/upload`, {
      method: "POST",
      headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (!json.status?.success) {
          const details = json.data.details || {};
          const paths = [];
          Object.values(details).forEach((arr) => paths.push(...arr));

          this.setState({
            validating: false,
            error: `The file contains errors`,
          });

          return;
        }
        const uuid = json.data.import.uuid;
        this.setState({ uuid });
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.setState({
              data: results.data,
              headers: results.meta.fields,
              validating: false,
            });
          },
          error: () =>
            this.setState({ validating: false, error: "CSV loading error" }),
        });
      })
      .catch(() =>
        this.setState({
          validating: false,
          error: "Network error during validation",
        })
      );
  }

  handleCommit() {
    const { uuid } = this.state;
    if (!uuid) return;

    this.setState({ committing: true, error: null });

    fetch(`${this.props.API}/campaign/assignment/import/commit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({ import: { uuid } }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (!json.status?.success) {
          const err = json.data?.error;
          console.warn("error: ", err);
          if (err === "error_assignment_file_version_mismatch") {
            this.setState({
              error:
                "Your file is out of date - please download the latest version and try again.",
              committing: false,
            });
          } else {
            this.setState({
              error: "Could not save changes",
              committing: false,
            });
          }
          return;
        } else {
          this.setState({ committing: false });
          window.dispatchEvent(
            new CustomEvent("NOTIFY", {
              detail: { type: "green", content: "Successfully added." },
            }),
            true
          );
          sessionStorage.setItem("notifyOnReload", "true");
          this.handleWithdraw();
          this.props.refreshAssignmentList();
        }
      })
      .catch(() =>
        this.setState({
          error: "Network error while saving changes",
          committing: false,
        })
      );
  }

  handleWithdraw() {
    this.setState({
      data: [],
      headers: [],
      error: null,
      errorList: [],
      uuid: null,
      committing: false,
    });
    if (this.fileInputRef.current) this.fileInputRef.current.value = "";
  }

  render() {
    const { data, headers, validating, error, errorList, uuid, committing } =
      this.state;
    const dateCols = ["Start", "Finish", "WindowStart", "WindowFinish"];

    return (
      <div className="csv-uploader mb-6">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-4">
            <label
              htmlFor="fileUpload"
              className="rounded-sm bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 hover:bg-gray-50 cursor-pointer"
            >
              Choose file
            </label>
            <input
              id="fileUpload"
              ref={this.fileInputRef}
              type="file"
              accept=".csv"
              onChange={this.handleFile}
              disabled={validating || committing}
              className="hidden"
            />
            {validating && (
              <span className="text-gray-600">Validating file...</span>
            )}
            {error && <div className="text-red-600 ml-4">{error}</div>}
          </div>
          {errorList.length > 0 && (
            <ul className="ml-4 list-disc text-sm text-red-700">
              {errorList.map((path, idx) => (
                <li key={idx}>{path}</li>
              ))}
            </ul>
          )}
          {uuid && !validating && !error && (
            <div className="flex gap-5">
              <button
                type="button"
                onClick={this.handleCommit}
                disabled={committing}
                className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 disabled:opacity-50 cursor-pointer"
              >
                {committing ? "Saving..." : "Save changes"}
              </button>
              <button
                type="button"
                onClick={this.handleWithdraw}
                disabled={committing}
                className="rounded-md bg-slate-50 px-3.5 py-2.5 text-sm font-semibold text-slate-600 shadow-xs hover:bg-slate-100 disabled:opacity-50 cursor-pointer"
              >
                Rollback changes
              </button>
            </div>
          )}
        </div>

        {data.length > 0 && !validating && !error && (
          <div className="overflow-auto mt-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {headers.map((h) => (
                    <th
                      key={h}
                      className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.map((row, i) => (
                  <tr key={i} className="even:bg-zinc-50 hover:bg-sky-50">
                    {headers.map((h) => {
                      let cell = row[h];
                      if (dateCols.includes(h) && cell) {
                        try {
                          cell = format(parseISO(cell), "dd.MM.yyyy");
                        } catch {}
                      }
                      return (
                        <td
                          key={h}
                          className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap"
                        >
                          {cell}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

class AssignmentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [], headers: [], loading: true };
    this.fetchData = this.fetchData.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleDownloadHandlers = this.handleDownloadHandlers.bind(this);
    this.handleDownloadAllQRs = this.handleDownloadAllQRs.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.campaignId !== this.props.campaignId) {
      this.fetchData();
    }
  }

  fetchData() {
    this.setState({ loading: true });
    const url = `${this.props.API}/campaign/assignment/list`;
    const params = {
      campaign: { ident: this.props.campaignId },
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((json) => {
        const assignments = json.data.assignments || [];
        const headers =
          assignments.length > 0 ? Object.keys(assignments[0]) : [];
        this.setState({ data: assignments, headers, loading: false });
      })
      .catch((err) => {
        console.error("API fetch error:", err);
        this.setState({ loading: false });
      });
  }

  handleDownload() {
    const url = `${this.props.API}/campaign/assignment/export`;
    const payload = {
      campaign: { ident: this.props.campaignId },
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("File download failed");
        return res.blob();
      })
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "assignments.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((err) => {
        console.error("Export error:", err);
        window.dispatchEvent(
          new CustomEvent("NOTIFY", {
            detail: { type: "red", content: "File download error." },
          }),
          true
        );
      });
  }

  handleDownloadHandlers() {
    const url = `${this.props.API}/store/export`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        campaign: { ident: this.props.campaignId },
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Nie udało się pobrać pliku");
        return res.blob();
      })
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "handlers.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((err) => {
        console.error("Handler export error:", err);
        window.dispatchEvent(
          new CustomEvent("NOTIFY", {
            detail: {
              type: "red",
              content: "Error downloading handlers file.",
            },
          }),
          true
        );
      });
  }

  handleDownloadAllQRs() {
    const url = `${this.props.API}/campaign/assignment/qrs`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        campaign: { ident: this.props.campaignId },
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("ZIP file download failed");
        return res.blob();
      })
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "all_qrs.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((err) => {
        console.error("QR ZIP download error:", err);
        window.dispatchEvent(
          new CustomEvent("NOTIFY", {
            detail: { type: "red", content: "QR ZIP download error." },
          }),
          true
        );
      });
  }

  render() {
    const { data, headers, loading } = this.state;
    const dateCols = ["start", "finish", "windowStart", "windowFinish"];

    if (loading) {
      return (
        <div className="flex items-center justify-center py-12">
          <svg
            className="animate-spin h-8 w-8 text-indigo-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          <span className="ml-4 text-indigo-600 text-sm">
            Loading assignments...
          </span>
        </div>
      );
    }
    if (data.length === 0) return <div>No data to display.</div>;

    const filteredHeaders = headers
      .filter(
        (header) =>
          header !== "effectiveCriteria" &&
          header !== "windowStart" &&
          header !== "windowFinish" &&
          header !== "qr" // usuwamy QR z miejsca, gdzie był wcześniej
      )
      .concat("window", "qr"); // dodajemy najpierw "window", potem "qr" na końcu

    return (
      <div className="assignment-list mb-6">
        <div className="flex justify-end mb-4 gap-2">
          <button
            type="button"
            onClick={this.handleDownload}
            className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 cursor-pointer"
          >
            Download current config
          </button>
          <button
            type="button"
            onClick={this.handleDownloadHandlers}
            className="rounded-md bg-slate-50 px-3.5 py-2.5 text-sm font-semibold text-slate-600 shadow-xs hover:bg-slate-100 disabled:opacity-50 cursor-pointer cursor-pointer"
          >
            Download current handler list
          </button>
          <button
            type="button"
            onClick={this.handleDownloadAllQRs}
            className="rounded-md bg-slate-50 px-3.5 py-2.5 text-sm font-semibold text-slate-600 shadow-xs hover:bg-slate-100 disabled:opacity-50 cursor-pointer cursor-pointer"
          >
            Download all QRs .zip
          </button>
        </div>

        <div className="overflow-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {filteredHeaders.map((header) => {
                  const headerLabels = {
                    active: "Enabled",
                    effective: "Active",
                    store: "POS (händlercode)",
                    promoter: "Promoter Code",
                    start: "Event Start",
                    finish: "Event Finish",
                    window: "Work Hrs",
                  };
                  const label = headerLabels[header] || header;

                  return (
                    <th
                      key={header}
                      className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {label}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((row, idx) => (
                <tr key={idx}>
                  {filteredHeaders.map((header) => {
                    let cell = row[header];

                    if (header === "window") {
                      const start = row.windowStart
                        ? parse(row.windowStart, "HH:mm:ss", new Date())
                        : null;
                      const finish = row.windowFinish
                        ? parse(row.windowFinish, "HH:mm:ss", new Date())
                        : null;

                      const formatted =
                        start && finish
                          ? `${format(start, "HH:mm")} - ${format(
                              finish,
                              "HH:mm"
                            )}`
                          : "";

                      return (
                        <td
                          key={header}
                          className="px-4 py-2 whitespace-nowrap text-sm text-gray-700"
                        >
                          {formatted}
                        </td>
                      );
                    }

                    // format daty
                    if (dateCols.includes(header) && cell) {
                      try {
                        const formatMap = {
                          start: "yy-MM-dd HH:mm",
                          finish: "yy-MM-dd HH:mm",
                          windowStart: "dd.MM.yyyy",
                          windowFinish: "dd.MM.yyyy",
                        };
                        const fmt = formatMap[header] || "dd.MM.yyyy";
                        cell = format(parseISO(cell), fmt);
                      } catch {}
                    }

                    // aktywność
                    if (header === "active" || header === "effective") {
                      cell = cell ? (
                        <div className="text-green-700 bg-green-50 ring-green-600/20 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset w-fit">
                          Active
                        </div>
                      ) : (
                        <div className="text-red-700 bg-red-50 ring-red-600/10 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset w-fit">
                          Inactive
                        </div>
                      );
                    }

                    // kod QR — przycisk download
                    if (
                      header === "qr" &&
                      cell &&
                      typeof cell === "object" &&
                      cell.data &&
                      cell.name
                    ) {
                      const { data: qrData, name: qrName } = cell;
                      cell = (
                        <button
                          className="text-indigo-600 hover:text-indigo-900 underline text-sm cursor-pointer"
                          onClick={() => {
                            try {
                              const base64Data = qrData.split(",")[1];
                              const byteCharacters = atob(base64Data);
                              const byteNumbers = new Array(
                                byteCharacters.length
                              )
                                .fill()
                                .map((_, i) => byteCharacters.charCodeAt(i));
                              const byteArray = new Uint8Array(byteNumbers);
                              const blob = new Blob([byteArray], {
                                type: "image/png",
                              });

                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob);
                              link.download = qrName || "qr.png";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              URL.revokeObjectURL(link.href);
                            } catch (error) {
                              console.error("QR download error", error);
                              window.dispatchEvent(
                                new CustomEvent("NOTIFY", {
                                  detail: {
                                    type: "red",
                                    content: "QR download error.",
                                  },
                                }),
                                true
                              );
                            }
                          }}
                        >
                          Download
                        </button>
                      );
                    }

                    // inne obiekty ładnie wyświetlone
                    const isObject =
                      cell !== null &&
                      typeof cell === "object" &&
                      !React.isValidElement(cell);

                    return (
                      <td
                        key={header}
                        className="px-4 py-2 whitespace-nowrap text-sm text-gray-700"
                      >
                        {isObject ? <JSONPretty data={cell} /> : cell}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

function getLabel(option) {
  return (
    option?.name ||
    option?.ident ||
    option?.code ||
    (typeof option === "string" ? option : JSON.stringify(option))
  );
}

// ---------- Komponent wykresu ----------
function SalesApiChart({ stats, periodType }) {
  // stats: [{timestamp, coupons, ...}]
  // periodType: "day" | "week" | "hour"
  if (!stats?.length) return null;

  // Formatowanie labeli na osi X
  function formatLabel(ts) {
    if (periodType === "week") return `CW ${ts}`;
    if (periodType === "hour") return ts.slice(11, 16); // HH:mm z "2025-05-23 10:00"
    if (periodType === "day") return ts.slice(5, 10); // MM-DD z "2025-05-16"
    return ts;
  }

  return (
    <div className="mt-8">
      <h3 className="text-lg font-semibold mb-2">
        Sales by{" "}
        {periodType === "week" ? "Week" : periodType === "day" ? "Day" : "Hour"}
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={stats}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="timestamp"
            angle={-45}
            textAnchor="end"
            height={60}
            tickFormatter={formatLabel}
          />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="coupons"
            stroke="#4f46e5"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

// ---------- Komponent wyboru czasu ----------
function TimeRangeSelector({
  mode,
  setMode,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  resetApiData,
}) {
  const options = [
    { value: "day", label: "Daily" },
    { value: "week", label: "Weekly" },
    { value: "hour", label: "Hourly" },
  ];

  const handleModeChange = (e) => {
    const value = e.target.value;
    setMode(value);
    resetApiData();
    if (value === "hour") {
      setEndDate(startDate);
    }
  };
  const handleStartChange = (e) => {
    setStartDate(e.target.value);
    if (mode === "hour") setEndDate(e.target.value);
    resetApiData();
  };
  const handleEndChange = (e) => {
    setEndDate(e.target.value);
    resetApiData();
  };

  return (
    <div className="flex gap-4 items-end">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Time Frame
        </label>
        <select
          value={mode}
          onChange={handleModeChange}
          className="rounded-md border border-gray-300 px-2 py-1 text-sm"
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {mode === "hour" ? "Day" : "From"}
        </label>
        <input
          type="date"
          value={startDate}
          onChange={handleStartChange}
          className="rounded-md border border-gray-300 px-2 py-1 text-sm"
        />
      </div>
      {mode !== "hour" && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            To
          </label>
          <input
            type="date"
            value={endDate}
            onChange={handleEndChange}
            className="rounded-md border border-gray-300 px-2 py-1 text-sm"
            min={startDate}
          />
        </div>
      )}
    </div>
  );
}

// ---------- Główny komponent ----------
export function FilterDropdowns({ API, campaignId }) {
  // --- dropdowny ---
  const [promoters, setPromoters] = useState([]);
  const [catalogues, setCatalogues] = useState([]);
  const [stores, setStores] = useState([]);

  const [selectedPromoters, setSelectedPromoters] = useState([]);
  const [selectedCatalogues, setSelectedCatalogues] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);

  const [queryPromoter, setQueryPromoter] = useState("");
  const [queryCatalogue, setQueryCatalogue] = useState("");
  const [queryStore, setQueryStore] = useState("");

  // --- daty, tryb ---
  const todayStr = format(new Date(), "yyyy-MM-dd");
  const [mode, setMode] = useState("hour");
  const [startDate, setStartDate] = useState(todayStr);
  const [endDate, setEndDate] = useState(todayStr);

  // --- loading/errors/dane ---
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [tableData, setTableData] = useState(null);

  // --- paginacja ---
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);

  const [downloadingCsv, setDownloadingCsv] = useState(false);

  // czyszczenie wyników
  const resetApiData = () => {
    setApiData(null);
    setApiError(null);
    setTableData(null);
    setPage(0);
    setTotal(0);
  };

  useEffect(() => {
    resetApiData();
  }, [campaignId]);

  useEffect(() => {
    setSelectedPromoters([]);
    setSelectedCatalogues([]);
    setSelectedStores([]);
  }, [campaignId]);

  // --- pobierz dropdowny ---
  useEffect(() => {
    if (!campaignId) {
      setPromoters([]);
      setCatalogues([]);
      return;
    }
    fetch(`${API}/report/filter/promoter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({ campaign: { ident: campaignId } }),
    })
      .then((res) => res.json())
      .then((json) => setPromoters(json.data?.promoters || []))
      .catch(() => setPromoters([]));

    fetch(`${API}/report/filter/catalogue`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({ campaign: { ident: campaignId } }),
    })
      .then((res) => res.json())
      .then((json) => setCatalogues(json.data?.catalogues || []))
      .catch(() => setCatalogues([]));
  }, [campaignId, API]);

  useEffect(() => {
    if (!campaignId) return;
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    };

    fetch(API + "/report/filter/promoter", {
      method: "POST",
      headers,
      body: JSON.stringify({ campaign: { ident: campaignId } }),
    })
      .then((r) => r.json())
      .then((json) => setPromoters(json.data?.promoters || []));

    fetch(API + "/report/filter/catalogue", {
      method: "POST",
      headers,
      body: JSON.stringify({ campaign: { ident: campaignId } }),
    })
      .then((r) => r.json())
      .then((json) => setCatalogues(json.data?.catalogues || []));

    fetch(API + "/report/filter/store", {
      method: "POST",
      headers,
      body: JSON.stringify({ campaign: { ident: campaignId } }),
    })
      .then((r) => r.json())
      .then((json) => setStores(json.data?.stores || []));
  }, [API, campaignId]);

  const MIN_QUERY_LENGTH = 3;

  // --- filtrowanie opcji ---
  // przefiltrowane listy z progiem
  const filteredPromoters = useMemo(
    () =>
      queryPromoter.length <= MIN_QUERY_LENGTH - 1
        ? []
        : promoters.filter((p) =>
            p.toLowerCase().includes(queryPromoter.toLowerCase())
          ),
    [promoters, queryPromoter]
  );

  const filteredCatalogues = useMemo(
    () =>
      queryCatalogue.length <= MIN_QUERY_LENGTH - 1
        ? []
        : catalogues.filter((c) =>
            c.toLowerCase().includes(queryCatalogue.toLowerCase())
          ),
    [catalogues, queryCatalogue]
  );

  const filteredStores = useMemo(
    () =>
      queryStore.length <= MIN_QUERY_LENGTH - 1
        ? []
        : stores.filter((s) =>
            s.toLowerCase().includes(queryStore.toLowerCase())
          ),
    [stores, queryStore]
  );

  // --- fetchuj dane wykres/tabela ---
  const handleShowData = async (goToPage = 0, newLimit = limit) => {
    setPage(goToPage);

    setApiError(null);
    setLoading(true);

    // Tworzymy payload do filtrów
    let endpoint = "/report/stats/daily";
    if (mode === "week") endpoint = "/report/stats/weekly";
    if (mode === "hour") endpoint = "/report/stats/hourly";

    const after = startDate;
    const before = mode === "hour" ? startDate : endDate;

    const filterPayload = {
      after,
      before,
      ...(campaignId && { campaign: [campaignId] }),
      ...(selectedPromoters.length > 0 && { promoter: selectedPromoters }),
      ...(selectedStores.length > 0 && { store: selectedStores }),
      ...(selectedCatalogues.length > 0 && { catalogue: selectedCatalogues }),
    };

    try {
      // 1. Pobieramy wykres
      if (goToPage === 0 || newLimit !== limit) {
        const res = await fetch(API + endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(filterPayload),
        });
        if (!res.ok) throw new Error("Error downloading data to chart");
        const json = await res.json();
        setApiData(json);
      }

      // 2. Pobieramy count (ilość wszystkich rekordów pasujących do filtrów)
      const resCount = await fetch(API + "/report/data/count", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(filterPayload),
      });
      if (!resCount.ok) throw new Error("Error getting data count");
      const jsonCount = await resCount.json();
      setTotal(jsonCount.data?.count || 0);

      // 3. Pobieramy dane do tabeli, paginacja!
      const resTable = await fetch(API + "/report/data/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          ...filterPayload,
          limit: newLimit,
          offset: goToPage * newLimit,
        }),
      });
      if (!resTable.ok) throw new Error("Error downloading data to table");
      const jsonTable = await resTable.json();
      setTableData(jsonTable.data?.coupons || []);
      // UWAGA: NIE ustawiamy już tutaj total, bo pochodzi z count
    } catch (e) {
      setApiError(e.message);
      setApiData(null);
      setTableData(null);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  async function handleDownloadAllData() {
    setDownloadingCsv(true);
    try {
      // 1. Zbuduj payload tak jak w handleShowData
      const filterPayload = {
        after: startDate,
        before: mode === "hour" ? startDate : endDate,
        ...(campaignId && { campaign: [campaignId] }),
        ...(selectedPromoters.length > 0 && { promoter: selectedPromoters }),
        ...(selectedStores.length > 0 && { store: selectedStores }),
        ...(selectedCatalogues.length > 0 && { catalogue: selectedCatalogues }),
      };

      // 2. Pobierz total count
      const countRes = await fetch(API + "/report/data/count", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(filterPayload),
      });
      if (!countRes.ok) throw new Error("Błąd pobierania count");
      const { data: { count: totalCount } = {} } = await countRes.json();

      // 3. Pętla po offsetach
      const batchSize = 1000;
      let allCoupons = [];
      for (let offset = 0; offset < totalCount; offset += batchSize) {
        const listRes = await fetch(API + "/report/data/list", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            ...filterPayload,
            limit: batchSize,
            offset,
          }),
        });
        if (!listRes.ok) throw new Error(`Błąd pobierania partii od ${offset}`);
        const json = await listRes.json();
        allCoupons = allCoupons.concat(json.data?.coupons || []);
      }

      // 4. Konwersja do CSV
      const csvString = Papa.unparse(allCoupons);

      // 5. Trigger download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "dbi_list.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      window.dispatchEvent(
        new CustomEvent("NOTIFY", {
          detail: { type: "red", content: "Nie udało się pobrać pełnego CSV." },
        }),
        true
      );
    } finally {
      setDownloadingCsv(false);
    }
  }

  // ---------- Tabela z paginacją ----------
  function CouponTable({ coupons }) {
    if (!coupons || coupons.length === 0)
      return (
        <div className="text-gray-500 mt-2 text-sm">
          No data to show. Try diffrent input.
        </div>
      );

    const headers = [
      "coupon_id",
      "session_id",
      "session_completed",
      "session_week",
      "promoter_ident",
      "store_ident",
      "catalogue_ident",
      "campaign_ident",
      "promoter_rating",
    ];

    const headerLabels = {
      coupon_id: "DBI_ID",
      session_id: "Session Id",
      session_completed: "Session Completed",
      session_week: "KW",
      promoter_ident: "Promoter",
      store_ident: "Ident",
      catalogue_ident: "Catalogue",
      campaign_ident: "Campaign",
      promoter_rating: "Promoter Rating",
    };

    const totalPages = Math.ceil(total / limit);

    return (
      <div className="overflow-x-auto mt-8 w-full">
        <div className="mb-2 flex items-center gap-4">
          <span>
            {`Results: ${total} | Page: ${page + 1} z ${totalPages || 1}`}
          </span>
          <label>
            Show:{" "}
            <select
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                handleShowData(0, Number(e.target.value));
              }}
              className="border px-1 py-0.5 rounded"
            >
              {[10, 20, 50, 100, 1000].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
          {/* Strzałki tylko jeśli jest więcej niż 1 strona */}
          {totalPages > 1 && total > limit && (
            <div className="flex gap-2">
              <button
                className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300"
                onClick={() => handleShowData(page - 1, limit)}
                disabled={page <= 0}
              >
                {"<"}
              </button>
              <button
                className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300"
                onClick={() => handleShowData(page + 1, limit)}
                disabled={page >= totalPages - 1}
              >
                {">"}
              </button>
            </div>
          )}
        </div>
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {headers.map((h) => (
                <th
                  key={h}
                  className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  {headerLabels[h] || h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {coupons.map((row) => (
              <tr key={row.coupon_id}>
                {headers.map((h) => (
                  <td
                    className="px-4 py-2 whitespace-nowrap text-sm text-gray-700 text-left"
                    key={h}
                  >
                    {h === "session_completed" && row[h]
                      ? format(parseISO(row[h]), "yyyy-MM-dd HH:mm")
                      : row[h] !== null && row[h] !== undefined
                      ? row[h]
                      : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  const hasTableData = Array.isArray(tableData) && tableData.length > 0;
  const hasChartData =
    Array.isArray(apiData?.data?.stats) && apiData.data.stats.length > 0;
  const canRefresh = !apiError && (hasTableData || hasChartData);

  // -------------- JSX główny --------------
  return (
    <div className="flex flex-col items-start gap-4 w-full">
      <div className="flex gap-4 items-end w-full flex-wrap">
        <TimeRangeSelector
          mode={mode}
          setMode={setMode}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          resetApiData={resetApiData}
        />
        {/* Promoter multiselect */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Promoter
          </label>
          <Multiselect
            options={filteredPromoters}
            selectedValues={selectedPromoters}
            onSelect={(list) => setSelectedPromoters(list)}
            onRemove={(list) => setSelectedPromoters(list)}
            onSearch={(txt) => setQueryPromoter(txt)}
            isObject={false}
            placeholder="Select promoters..."
            emptyRecordMsg={
              !campaignId
                ? "Select campaign to search"
                : queryPromoter.length < MIN_QUERY_LENGTH
                ? `Type more 🔎`
                : "No matches 📂"
            }
            style={{ multiselectContainer: { width: "14rem" } }}
          />
        </div>

        {/* Catalogue multiselect */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Catalogue
          </label>
          <Multiselect
            options={filteredCatalogues}
            selectedValues={selectedCatalogues}
            onSelect={(list) => setSelectedCatalogues(list)}
            onRemove={(list) => setSelectedCatalogues(list)}
            onSearch={(txt) => setQueryCatalogue(txt)}
            isObject={false}
            placeholder="Select catalogues..."
            emptyRecordMsg={
              !campaignId
                ? "Select campaign to search"
                : queryCatalogue.length < MIN_QUERY_LENGTH
                ? `Type more 🔎`
                : "No matches 📂"
            }
            style={{ multiselectContainer: { width: "14rem" } }}
          />
        </div>

        {/* Store multiselect */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Store
          </label>
          <Multiselect
            options={filteredStores}
            selectedValues={selectedStores}
            onSelect={(list) => setSelectedStores(list)}
            onRemove={(list) => setSelectedStores(list)}
            onSearch={(txt) => setQueryStore(txt)}
            isObject={false}
            placeholder="Select stores..."
            emptyRecordMsg={
              !campaignId
                ? "Select campaign to search"
                : queryStore.length < MIN_QUERY_LENGTH
                ? `Type more 🔎`
                : "No matches 📂"
            }
            style={{ multiselectContainer: { width: "14rem" } }}
          />
        </div>
        {/* Przycisk */}
        <button
          type="button"
          onClick={() => handleShowData(0, limit)}
          disabled={loading}
          className={`rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs disabled:opacity-50 cursor-pointer
          ${
            loading
              ? "bg-gray-400"
              : canRefresh
              ? "bg-emerald-600 hover:bg-emerald-500 focus-visible:outline-emerald-600"
              : "bg-blue-500 hover:bg-blue-400 focus-visible:outline-blue-500"
          }
        `}
        >
          {loading ? "Loading..." : canRefresh ? "Refresh" : "Show data"}
        </button>

        {/* ... istniejące elementy ... */}
        {canRefresh && (
          <button
            type="button"
            onClick={handleDownloadAllData}
            disabled={downloadingCsv}
            className={`rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs cursor-pointer
      ${
        downloadingCsv
          ? "bg-gray-400"
          : "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
      }`}
          >
            {downloadingCsv ? "Downloading..." : "Download CSV"}
          </button>
        )}
      </div>
      {/* Wyświetlanie błędu, wykresu i tabeli */}
      {apiError && (
        <span className="ml-4 text-red-600 text-sm">{apiError}</span>
      )}
      {loading && (
        <div className="flex items-center justify-center py-12">
          <svg
            className="animate-spin h-8 w-8 text-indigo-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          <span className="ml-4 text-indigo-600 text-sm">Loading data...</span>
        </div>
      )}

      {!loading && apiData?.data?.stats && (
        <div className="w-full mt-4">
          <SalesApiChart stats={apiData.data.stats} periodType={mode} />
        </div>
      )}
      {!loading && tableData && <CouponTable coupons={tableData} />}
    </div>
  );
}

// Tabelka z statycznymi danymi
const transactions = [
  {
    id: "1",
    kw: "***",
    dataTime: "2025-05-22 13:16",
    promotorCode: "22923",
    pos: "AAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "2",
    kw: "***",
    dataTime: "2025-05-23 22:33",
    promotorCode: "11923",
    pos: "BAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.1",
    promoterRating: "2",
  },
  {
    id: "21",
    kw: "***",
    dataTime: "2025-05-23 22:33",
    promotorCode: "11123",
    pos: "BBECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.1",
    promoterRating: "2",
  },
  {
    id: "3",
    kw: "***",
    dataTime: "2025-05-24 9:16",
    promotorCode: "33923",
    pos: "CAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.7",
    promoterRating: "5",
  },
  {
    id: "4",
    kw: "***",
    dataTime: "2025-05-25 13:16",
    promotorCode: "44923",
    pos: "DAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.8",
    promoterRating: "3",
  },
  {
    id: "5",
    kw: "***",
    dataTime: "2025-05-26 17:16",
    promotorCode: "55923",
    pos: "EAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "6",
    kw: "***",
    dataTime: "2025-05-27 17:16",
    promotorCode: "65923",
    pos: "FAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "7",
    kw: "***",
    dataTime: "2025-05-28 17:16",
    promotorCode: "75923",
    pos: "GAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "8",
    kw: "***",
    dataTime: "2025-05-29 17:16",
    promotorCode: "85923",
    pos: "HAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "9",
    kw: "***",
    dataTime: "2025-05-30 17:16",
    promotorCode: "95923",
    pos: "IAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "10",
    kw: "***",
    dataTime: "2025-05-31 17:16",
    promotorCode: "10923",
    pos: "JAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "11",
    kw: "***",
    dataTime: "2025-05-31 17:16",
    promotorCode: "10923",
    pos: "KAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "12",
    kw: "***",
    dataTime: "2025-05-31 17:16",
    promotorCode: "10923",
    pos: "LAECAS",
    offerId: "Vuse_Ultra_2_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "13",
    kw: "***",
    dataTime: "2025-06-01 17:16",
    promotorCode: "11923",
    pos: "MAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "14",
    kw: "***",
    dataTime: "2025-06-02 17:16",
    promotorCode: "11923",
    pos: "NAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "15",
    kw: "***",
    dataTime: "2025-06-03 17:16",
    promotorCode: "11923",
    pos: "OAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  {
    id: "16",
    kw: "***",
    dataTime: "2025-06-03 12:16",
    promotorCode: "11923",
    pos: "PAECAS",
    offerId: "Vuse_Ultra_3_packs",
    fraudscore: "0.2",
    promoterRating: "5",
  },
  // More transactions...
];

function PromoterMultiSelect({ options, selected, setSelected }) {
  const [query, setQuery] = useState("");

  const filtered =
    query === ""
      ? options
      : options.filter((o) => o.toLowerCase().includes(query.toLowerCase()));

  const toggleSelection = (item) => {
    if (selected.includes(item)) {
      setSelected(selected.filter((s) => s !== item));
    } else {
      setSelected([...selected, item]);
    }
  };

  return (
    <Combobox as="div" value={selected} onChange={() => {}}>
      <div className="relative mt-1">
        <div className="relative w-64 cursor-default overflow-hidden rounded-md bg-white text-left shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm">
          <Combobox.Input
            className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
            onChange={(e) => setQuery(e.target.value)}
            displayValue={() => selected.join(", ")}
            placeholder="Select..."
          />
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </Combobox.Button>
        </div>

        {filtered.length > 0 && (
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-64 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {filtered.map((item) => (
              <Combobox.Option
                key={item}
                value={item}
                onClick={() => toggleSelection(item)}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pl-10 pr-4 ${
                    active ? "bg-indigo-600 text-white" : "text-gray-900"
                  }`
                }
              >
                {({ active }) => (
                  <>
                    <span
                      className={`block truncate ${
                        selected.includes(item) ? "font-medium" : "font-normal"
                      }`}
                    >
                      {item}
                    </span>
                    {selected.includes(item) && (
                      <span
                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                          active ? "text-white" : "text-indigo-600"
                        }`}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}

export function SalesChart({ transactions, startDate, endDate }) {
  const parsedData = transactions.map((t) => ({
    ...t,
    date: parse(t.dataTime, "yyyy-MM-dd HH:mm", new Date()),
  }));

  const diffDays =
    (new Date(endDate).getTime() - new Date(startDate).getTime()) /
    (1000 * 60 * 60 * 24);

  const isWeekly = diffDays > 30;

  const grouped = {};

  for (const t of parsedData) {
    const key = isWeekly
      ? `CW ${getWeek(t.date)}`
      : format(t.date, "yyyy-MM-dd");

    if (!grouped[key]) grouped[key] = 0;
    grouped[key]++;
  }

  const chartData = Object.entries(grouped).map(([key, count]) => ({
    date: key,
    count,
  }));

  return (
    <div className="mt-8">
      <h3 className="text-lg font-semibold mb-2">
        Sales by {isWeekly ? "Week" : "Day"}
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            angle={-45}
            textAnchor="end"
            height={60}
            tickFormatter={(value) => {
              if (value.startsWith("CW")) return value; // już sformatowane
              const parsed = parse(value, "yyyy-MM-dd", new Date());
              return format(parsed, "dd.MM");
            }}
          />
          <YAxis tickCount={1} tickFormatter={(value) => Math.floor(value)} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#4f46e5"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function StaticData() {
  const [startDate, setStartDate] = useState(
    format(subDays(new Date(), 7), "yyyy-MM-dd")
  );
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [selectedPromoters, setSelectedPromoters] = useState([]);
  const [selectedPos, setSelectedPos] = useState([]);
  const [selectedOffers, setSelectedOffers] = useState([]);

  const transactionsInDateRange = useMemo(() => {
    return transactions.filter(({ dataTime }) => {
      const txDate = parse(dataTime, "yyyy-MM-dd HH:mm", new Date());
      return (
        (!startDate || isAfter(txDate, new Date(startDate))) &&
        (!endDate || isBefore(txDate, new Date(endDate + "T23:59:59")))
      );
    });
  }, [startDate, endDate]);

  const uniquePromoters = useMemo(() => {
    return Array.from(
      new Set(transactionsInDateRange.map((t) => t.promotorCode))
    ).sort();
  }, [transactionsInDateRange]);

  const uniquePos = useMemo(() => {
    return Array.from(
      new Set(transactionsInDateRange.map((t) => t.pos))
    ).sort();
  }, [transactionsInDateRange]);

  const uniqueOffers = useMemo(() => {
    return Array.from(
      new Set(transactionsInDateRange.map((t) => t.offerId))
    ).sort();
  }, [transactionsInDateRange]);

  const filteredTransactions = useMemo(() => {
    return transactions.filter(({ dataTime, promotorCode, pos, offerId }) => {
      const txDate = parse(dataTime, "yyyy-MM-dd HH:mm", new Date());

      const matchesDate =
        (!startDate || isAfter(txDate, new Date(startDate))) &&
        (!endDate || isBefore(txDate, new Date(endDate + "T23:59:59")));

      const matchesPromoter =
        selectedPromoters.length === 0 ||
        selectedPromoters.includes(promotorCode);

      const matchesPos = selectedPos.length === 0 || selectedPos.includes(pos);

      const matchesOffer =
        selectedOffers.length === 0 || selectedOffers.includes(offerId);

      return matchesDate && matchesPromoter && matchesPos && matchesOffer;
    });
  }, [startDate, endDate, selectedPromoters, selectedPos, selectedOffers]);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mb-4 flex gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            From
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="rounded-md border border-gray-300 px-2 py-1 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            To
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="rounded-md border border-gray-300 px-2 py-1 text-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Promoters
          </label>
          <PromoterMultiSelect
            options={uniquePromoters}
            selected={selectedPromoters}
            setSelected={setSelectedPromoters}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            POS (handlercode)
          </label>
          <PromoterMultiSelect
            options={uniquePos}
            selected={selectedPos}
            setSelected={setSelectedPos}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Offer ID
          </label>
          <PromoterMultiSelect
            options={uniqueOffers}
            selected={selectedOffers}
            setSelected={setSelectedOffers}
          />
        </div>
      </div>

      <SalesChart
        transactions={filteredTransactions}
        startDate={startDate}
        endDate={endDate}
      />

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                DBI_ID
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold">CW</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                Data
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                Promoter
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold">POS</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                Offer
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                Fraud
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold">
                Rating
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredTransactions.map((transaction) => (
              <tr key={transaction.id}>
                <td className="px-4 py-2 text-sm">{transaction.id}</td>
                <td className="px-4 py-2 text-sm">{transaction.kw}</td>
                <td className="px-4 py-2 text-sm">{transaction.dataTime}</td>
                <td className="px-4 py-2 text-sm">
                  {transaction.promotorCode}
                </td>
                <td className="px-4 py-2 text-sm">{transaction.pos}</td>
                <td className="px-4 py-2 text-sm">{transaction.offerId}</td>
                <td className="px-4 py-2 text-sm">{transaction.fraudscore}</td>
                <td className="px-4 py-2 text-sm">
                  {transaction.promoterRating}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// pojedynczy katalog
export const CatalogueCard = ({ catalogue }) => {
  const {
    content: { title, description },
    thumbnail: { file: { url } = {} } = {},
    visibleFrom,
    visibleTo,
    turbo,
    raffle,
    active,
  } = catalogue;

  const fmt = (iso) => format(parseISO(iso), "dd.MM.yyyy", { locale: pl });
  const dateRange = `${fmt(visibleFrom)}–${fmt(visibleTo)}`;

  // wybieramy etykietę
  const badgeLabel = turbo ? "Turbo" : raffle ? "Raffle" : "Offer";

  // dobieramy kolory badge (możesz dopasować klasy)
  const badgeClasses = turbo
    ? "bg-blue-50 text-blue-600 "
    : raffle
    ? "bg-indigo-50 text-indigo-600 "
    : "bg-gray-50 text-gray-600";

  return (
    <article className="flex flex-col items-start justify-between">
      <div className="h-40 relative w-full isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-3 aspect-1/2 lg:aspect-4/2">
        <img
          src={url}
          alt={title}
          className="absolute inset-0 -z-10 size-full object-cover"
        />
        <div className="absolute inset-0 -z-10 bg-linear-to-t from-gray-400 via-gray-400/40"></div>
        {/* {active ? (
          <div className="absolute inset-0 -z-10 bg-linear-to-t from-green-300/40 via-stone-100/10"></div>
        ) : (
          <div className="absolute inset-0 -z-10 bg-linear-to-t from-stone-400 via-stone-400/40"></div>
        )} */}
        <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-gray-900/10 ring-inset"></div>

        <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm/6 text-white-300">
          <div className="-ml-4 flex items-center gap-x-4">
            <svg
              viewBox="0 0 2 2"
              className="-ml-0.5 size-0.5 flex-none fill-white/50"
            >
              <circle cx="1" cy="1" r="1" />
            </svg>
            <div className="flex gap-x-2.5">
              {active ? "✅ Active" : "🛑 Paused  "}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-xl">
        <div className="mt-2 flex items-center gap-x-4 text-xs">
          <time dateTime={visibleFrom} className="text-gray-500">
            {dateRange}
          </time>
          <span
            className={`relative z-10 rounded-full px-3 py-1.5 font-medium ${badgeClasses}`}
          >
            {badgeLabel}
          </span>
        </div>

        <div className="group relative">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gray-600">
            <span className="absolute inset-0" />
            {title}
          </h3>
          <p className="mt-2 line-clamp-3 text-sm text-gray-600">
            {description}
          </p>
        </div>
      </div>
    </article>
  );
};

// komponent listy
export const CatalogueList = ({ catalogues }) => {
  if (!Array.isArray(catalogues) || catalogues.length === 0) {
    return <div>No catalogues to display.</div>;
  }

  return (
    <>
      {catalogues.map((cat) => (
        <CatalogueCard key={cat.uuid} catalogue={cat} />
      ))}
    </>
  );
};

export default class ListPage extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      wholeData: {},
      catalogues: [],
      itemId: null,
      preloader: true,
      searchTerm: "",
      page: 0,
      pages: 0,
      category: "test",
      sortBy: "publicationDate",
      filters: {},
      mapUUID: "",
      dateBefore: new Date(),
      dateAfter: new Date(),
      campaignId: null,
      assignmentListKey: Date.now(),
    };
    this._bind(
      "delete",
      "getData",
      "searchUpdated",
      "closeConfirm",
      "handlePageClick"
    );

    this.handleSearch = _.debounce(() => {
      this.setState({ list: [], preloader: true });
      this.getData(this.state.mapUUID);
    }, 600);
  }

  handleCampaignChange = (newId) => {
    this.setState({ campaignId: newId }, () => {
      this.getData(); // pobierz dane po zmianie kampanii
    });
  };

  refreshAssignmentList = () => {
    this.setState({ assignmentListKey: Date.now() });
  };

  getData() {
    if (!this.state.campaignId) {
      // Nie wykonujemy fetcha, bo kampania nie została jeszcze ustawiona
      return;
    }

    this.setState({ preloader: true });
    const url = `${this.props.API}/campaign/describe`;
    const params = {
      campaign: { ident: this.state.campaignId },
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((result) => {
        if (!result.status.success) {
          // 📝 Zmień to całe seesion storage bo ta aplikacja już tego nie potrzebuje
          // window.dispatchEvent(
          //   new CustomEvent("NOTIFY", {
          //     detail: { type: "red", content: errorMap(result.data?.error) },
          //   }),
          //   true
          // );
        } else {
          const catalogues = result.data.catalogues || [];
          this.setState({
            catalogues,
            preloader: false,
          });
          this.setState({
            wholeData: result.data,
            preloader: false,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ preloader: false });
      });
  }

  componentDidMount() {
    if (this.state.campaignId) {
      this.getData();
    }
    const shouldNotify = sessionStorage.getItem("notifyOnReload");
    if (shouldNotify === "true") {
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("NOTIFY", {
            detail: { type: "green", content: "Successfully added." },
          }),
          true
        );
        sessionStorage.removeItem("notifyOnReload");
      }, 500);
    }
  }

  delete(id) {
    this.setState({ preloader: true });
    let url = this.props.API + "/admin/gallery/find";
    const params = {
      [this.props.data.table]: {
        uuid: id,
      },
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        return response.json();
      })
      .then(
        (result) => {
          //console.log(result)
          this.setState({ confirm: false, itemId: null });
          this.getData();
          if (!result.status.success) {
            window.dispatchEvent(
              new CustomEvent("NOTIFY", {
                detail: {
                  type: "red",
                  content: errorMap(
                    result.data?.error?.ident || result.data?.error
                  ),
                },
              }),
              true
            );
          } else {
            window.dispatchEvent(
              new CustomEvent("NOTIFY", {
                detail: { type: "green", content: "Successfully remove." },
              }),
              true
            );
          }
        },
        (error) => {
          console.log(error);
          window.dispatchEvent(
            new CustomEvent("NOTIFY", {
              detail: { type: "red", content: "Something went wrong." },
            }),
            true
          );
          this.setState({ preloader: false });
        }
      );
  }

  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null });
  }

  handlePageClick(data) {
    this.setState({ page: data.selected, preloader: true }, () => {
      this.getData(this.state.mapUUID);
    });
  }

  render() {
    let list = null;

    let filteredList = this.state.list;

    const Confirm = (
      <div className="confirm">
        <h4>Are you sure?</h4>
        <div className="btn-holder">
          <button className="btn" onClick={this.closeConfirm}>
            <span>No</span>
          </button>
          <button
            className="btn"
            onClick={this.delete.bind(null, this.state.itemId)}
          >
            <span>Yes</span>
          </button>
        </div>
      </div>
    );

    if (filteredList?.length > 0) {
      const sortedList =
        this.props.data.table === "articles" ||
        this.props.data.table === "offers" ||
        this.props.data.table === "events" ||
        this.props.data.table === "faq"
          ? _.orderBy(filteredList, [this.state.sortBy], ["desc"])
          : filteredList;
      list = sortedList.map((item, i) => {
        return (
          <li key={i}>
            <JSONPretty id="json-pretty" data={item}></JSONPretty>
          </li>
        );
      });
    }

    const campaignId = sessionStorage.getItem("campaignId");

    const fmt = (iso) => format(parseISO(iso), "dd.MM.yyyy", { locale: pl });
    const dateRange1 =
      this.state.wholeData.visibleFrom && this.state.wholeData.visibleTo
        ? `${fmt(this.state.wholeData.visibleFrom)}–${fmt(
            this.state.wholeData.visibleTo
          )}`
        : "";

    return (
      <section className="list px-2 sm:px-4 lg:px-6 ">
        <div className="overflow-hidden py-6 sm:py-12 h-[400px] mb-[300px]">
          <div className="mx-auto max-w-7xl md:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2 lg:items-start">
              <div className="px-6 lg:px-0 lg:pt-4 lg:pr-4">
                <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg">
                  <p className="text-base/7 font-semibold text-gray-600">
                    {dateRange1}
                  </p>
                  <h2 className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                    {this.state?.wholeData?.content?.title}
                  </h2>
                  <p className="mt-6 text-lg/8 text-gray-600">
                    {this.state?.wholeData?.content?.title}
                  </p>
                </div>
              </div>
              <div className="relative">
                <img
                  src={this.state?.wholeData?.hero_image?.file?.url}
                  alt={this.state?.wholeData?.content?.title}
                  className="-mb-12 w-228  rounded-tl-xl bg-gray-800 ring-1 ring-white/10 sm:rounded-3xl"
                />
                <CampaignForm
                  API={this.props.API}
                  onChange={this.handleCampaignChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-[-300px]">
          <div className="py-6 sm:py-12">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-2xl text-center">
                <h2 className="text-2xl font-semibold tracking-tight text-balance text-gray-900 sm:text-4xl">
                  Available offers
                </h2>
              </div>
              <div className="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                <CatalogueList catalogues={this.state.catalogues} />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <h3 className="text-lg font-semibold mb-2">
            Upload new file {this.state?.wholeData?.content?.title}:
          </h3>
          <CsvUploader
            API={this.props.API}
            campaignId={this.state.campaignId}
            refreshAssignmentList={this.refreshAssignmentList}
          />
        </div>

        <div className="container">
          <h3 className="text-lg font-semibold mb-2">
            Promoter Assignment Center {this.state?.wholeData?.content?.title}:
          </h3>
          <AssignmentList
            API={this.props.API}
            campaignId={this.state.campaignId}
            key={this.state.assignmentListKey}
          />
        </div>

        {/* <div className="container">
          <div className="py-6 sm:py-12">
            <div className="mx-auto ">
              <div className="mx-auto text-center">
                <StaticData />
              </div>
            </div>
          </div>
        </div> */}

        <div className="container">
          <div className="py-6 sm:py-12 h-96">
            <div className="mx-auto ">
              <h3 className="text-lg font-semibold mb-2">DBI List</h3>
              <h4 className="text-base  mb-2">
                Report of registrations in{" "}
                {this.state.campaignId ? (
                  <span>
                    <span className="font-semibold">
                      {this.state.campaignId}
                    </span>{" "}
                    campaign
                  </span>
                ) : (
                  <span className="font-semibold">all campaigns</span>
                )}
              </h4>
              <div className="mx-auto text-center">
                <FilterDropdowns
                  API={this.props.API}
                  campaignId={this.state.campaignId}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal open={this.state.confirm} hidePopup={this.closeConfirm}>
          {Confirm}
        </Modal>
      </section>
    );
  }
}
